// https://github.com/sulu/sulu-demo/pull/78/files

// @flow
import React from "react";
import Moment from "moment";
import { observer } from "mobx-react";
import { Route } from "sulu-admin-bundle/services/Router";
import { ResourceRequester } from "sulu-admin-bundle/services";
import type { Element, Node } from "react";
import styles from "./headerStyle.scss";
import overrides from "./../../../css/customization.scss";

import fonts from "./../../../css/components/fonts.scss";
import Loader from "sulu-admin-bundle/components/Loader";

type Props<T> = {
    ...ViewProps,
    children?: (T) => Element<*> | null,
    childrenProps: T,
    header?: Node,
    routeChildren?: Array<Route>,
    selectedIndex?: number,
    title?: string,
};

@observer
class HeaderView<T> extends React.Component<Props<T>> {
    static defaultProps = {
        childrenProps: {},
    };
    //Initialize defaultProps
    #pageProps = {
        id: null,
        locale: null,
        tab: null,
        resourceKey: null,
    };

    redirectToRouteWithHighestPriorityDisposer: () => void;

    constructor(props: Props<T>) {
        super(props);

        this.#pageProps = {
            id: props?.router?.attributes?.id,
            locale: props?.router?.attributes?.locale,
            tab: null,
            resourceKey: props?.route?.children[0]?.options?.resourceKey,
        };

        this.state = {
            leagueName: [],
            routerId: this.props.router.attributes.id,
            isLoading: false,
            matchData: null,
        };

        this.unlisten = null;
    }

    componentDidMount() {
        const { locale, id } = this.props.router.attributes;
        this.loadData(id, locale);

        this.unlisten = this.props.router.history.listen(() => {
            if (this.props.router.attributes.id !== this.state.routerId) {
                this.setState({
                    routerId: this.props.router.attributes.id,
                });
                this.loadData(this.props.router.attributes.id, locale);
            }
        });
    }

    componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    }

    loadData = async (id, locale) => {
        this.setState({ isLoading: true });

        try {
            const matchData = await ResourceRequester.get("dhbmatches", {
                id,
                locale,
            });

            const homeTeamLogo = matchData?.homeTeamObject?.logo
                ? await ResourceRequester.get("media", {
                      id: matchData.homeTeamObject.logo,
                      locale,
                  })
                : null;
            const awayTeamLogo = matchData?.awayTeamObject?.logo
                ? await ResourceRequester.get("media", {
                      id: matchData.awayTeamObject.logo,
                      locale,
                  })
                : null;

            this.setState({
                matchData: {
                    ...matchData,
                    homeTeam: matchData.homeTeamName,
                    awayTeam: matchData.awayTeamName,
                    homeTeamLogo:
                        homeTeamLogo?.thumbnails?.["image-150.webp"] || "",
                    awayTeamLogo:
                        awayTeamLogo?.thumbnails?.["image-150.webp"] || "",
                    matchDate: Moment(matchData.scheduleDate).format(
                        "D[.] MMMM YYYY"
                    ),
                    matchTime: matchData.scheduleTime,
                    gameNum: matchData.id,
                },
                isLoading: false,
            });
        } catch (error) {
            console.log(error);
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { matchData, isLoading } = this.state;

        const childComponent = this.props.children
            ? this.props.children(this.props.childrenProps)
            : null;

        let added = 0;
        let upcoming = 1;
        let warmup = 2;
        let inprogress = 3;
        let ended = 4;
        let completed = 5;
        let official = 6;
        let rated = 9;
        let progressResultMatch;
        let resultMatch;
        let matchTime;

        if (!matchData || isLoading) {
            return (
                <div id={overrides.league} className={styles.league}>
                    <Loader />
                </div>
            );
        }
        const currentStatus = matchData.status;

        if (currentStatus === added) {
            added = "activeMatch";
        } else if (currentStatus === upcoming) {
            upcoming = "activeMatch";
        } else if (currentStatus === warmup) {
            warmup = "active";
            added = upcoming = "passed";
        } else if (currentStatus === inprogress) {
            matchTime = "hide";
            inprogress = progressResultMatch = "active";
            added = warmup = upcoming = "passed";
        } else if (currentStatus === ended || currentStatus === rated) {
            matchTime = "hide";
            ended = resultMatch = "active";
            added = warmup = upcoming = inprogress = "passed";
        } else if (currentStatus === completed) {
            matchTime = "hide";
            completed = resultMatch = "active";
            ended = added = warmup = upcoming = inprogress = "passed";
        } else if (currentStatus === official) {
            matchTime = "hide";
            official = resultMatch = "active";
            completed =
                ended =
                added =
                warmup =
                upcoming =
                inprogress =
                    "passed";
        }

        return (
            <>
                <div id={overrides.league} className={styles.league}>
                    <div style={{ display: "flex" }}>
                        <p className={`${styles.leagueName} ${fonts.fs16}`}>
                            {matchData.leagueName} <br />
                            Spiel {matchData.gameNum}
                        </p>
                        <div className={styles.team}>
                            <img src={matchData.homeTeamLogo} />
                            <h2> {matchData.homeTeam}</h2>
                            <span className={styles.teamSeparation}>-</span>
                        </div>

                        <div className={styles.team}>
                            <img src={matchData.awayTeamLogo} />
                            <h2> {matchData.awayTeam} </h2>
                        </div>
                        <div
                            id={styles[matchTime]}
                            className={styles.matchTime}
                            style={{
                                paddingLeft: "50px",
                                alignSelf: "center",
                                fontSize: "16px",
                            }}
                        >
                            {matchData.matchDate} <br />
                            {matchData.matchTime?.replace(/-/g, ":")} Uhr
                        </div>
                        <div
                            id={styles[progressResultMatch]}
                            className={styles.progressResultMatch}
                        >
                            <p className={fonts.fs24}>
                                <span>{matchData.homeGoals}</span>-
                                <span>{matchData.awayGoals}</span>
                            </p>
                            <p className={fonts.fs16}>
                                1. Halbzeit <br />
                                23:45 min
                            </p>
                        </div>
                        <div
                            id={styles[resultMatch]}
                            className={styles.resultMatch}
                        >
                            <p>
                                <strong>
                                    {matchData.homeGoals} -{" "}
                                    {matchData.awayGoals}
                                </strong>
                            </p>

                            <p>
                                ({matchData.homeHTGoals} -{" "}
                                {matchData.awayHTGoals})
                            </p>
                        </div>
                    </div>
                    <div style={{ display: "flex", padding: "0 15px" }}>
                        <p id={styles[added]} className={styles.offlineMatch}>
                            (0) IN VORBEREITUNG{" "}
                        </p>
                        <p
                            id={styles[upcoming]}
                            className={styles.offlineMatch}
                        >
                            (0) IN VORBEREITUNG
                        </p>
                        <div
                            id={styles[warmup]}
                            className={`${styles.matchStatus} ${fonts.fs16}`}
                        >
                            <p> 1 </p>
                            <p className={styles.NameStatus}>VOR DEM SPIEL</p>
                        </div>

                        <div
                            id={styles[inprogress]}
                            className={`${styles.matchStatus} ${fonts.fs16}`}
                        >
                            <p> 2 </p>
                            <p className={styles.NameStatus}>SPIEL LÄUFT</p>
                        </div>

                        <div
                            id={styles[ended]}
                            className={`${styles.matchStatus} ${fonts.fs16}`}
                        >
                            <p> 3 </p>
                            <p className={styles.NameStatus}>
                                {currentStatus === rated
                                    ? "WERTUNG"
                                    : "SPIEL BEENDET"}
                            </p>
                        </div>

                        <div
                            id={styles[completed]}
                            className={`${styles.matchStatus} ${fonts.fs16}`}
                        >
                            <p> 4 </p>
                            <p className={styles.NameStatus}>ABGESCHLOSSEN</p>
                        </div>

                        <div
                            id={styles[official]}
                            className={`${styles.matchStatus} ${fonts.fs16}`}
                        >
                            <p> 5 </p>
                            <p className={styles.NameStatus}>OFFIZIELL</p>
                        </div>
                    </div>
                </div>
                {this.props.header}
                {childComponent}
            </>
        );
    }
}

export default HeaderView;
